export const media = {
    mobile: '@media(max-width: 768px)',
    tablet: '@media(max-width: 1024px)',
    desktop: '@media(min-width: 1025px)',
    respond1: '@media(max-width: 60em)',
    respond2: '@media(max-width: 72em)',
    respond3: '@media(max-width: 82em)',
    respond35: '@media(max-width: 90em)',
    respond4: '@media(max-width: 97em)',
    portrait: '@media(orientation: portrait) and (max-width: 90em)',
    touch: '@media (hover: none) and (pointer: coarse)',
    touchTablet:
        '@media (hover: none) and (pointer: coarse) and (min-width: 769px)',
};

export const rgba = (theme, colorName, opacity) => {
    return `rgba(${theme[colorName]}, ${opacity})`;
};

export const p3 = (theme, colorName, opacity) => {
    return `color(display-p3 ${theme[colorName]} / ${opacity})`;
};

export const lightTheme = {
    black: '36, 21, 56',
    white: '252, 244, 241',

    gradL: '255, 234, 215',
    gradR: '255, 225, 230',

    colorAI: '251, 213, 186',
    colorYou: '193, 196, 254',
    colorCorrect: '3, 7, 215',
    colorTranslate: '255, 230, 181',
    colorAccent: '53, 13, 212',
    colorUI: '237, 213, 203',

    colortextAi: '55, 35, 24',
    colortextYou: '35, 36, 60',
    colortextCorrect: '234, 234, 254',

    pgradL: '1 0.9244 0.8605',
    pgradR: '0.9747 0.8882 0.9026',

    pcolorAI: '0.9837 0.8352 0.7291',
    pcolorYou: '0.7558 0.7681 0.9961',
    pcolorCorrect: '0.0137 0.0282 0.843',
    pcolorTranslate: '1 0.903 0.709',
    pcolorAccent: '0.2087 0.0528 0.8324',
    pcolorUI: '0.9286 0.8351 0.7977',

    pcolortextAi: '0.2163 0.1387 0.0937',
    pcolortextYou: '0.137 0.1421 0.2346',
    pcolortextCorrect: '0.9196 0.9196 0.9942',
};

export const darkTheme = {
    black: '197, 204, 217',
    white: '47, 51, 60',

    gradL: '33, 28, 31',
    gradR: '23, 17, 23',

    colorAI: '69, 48, 73',
    colorYou: '48, 63, 94',
    colorCorrect: '218, 191, 150',
    colorTranslate: '255, 251, 181',
    colorAccent: '80, 100, 255',
    colorUI: '48, 46, 61',

    colortextAi: '217, 199, 213',
    colortextYou: '185, 193, 209',
    colortextCorrect: '34, 23, 7',

    pgradL: '0.1229 0.1105 0.1204',
    pgradR: '0.0849 0.0693 0.0888',

    pcolorAI: '0.2693 0.1866 0.2858',
    pcolorYou: '0.1887 0.2486 0.3683',
    pcolorCorrect: '0.8558 0.7495 0.5899',
    pcolorTranslate: '1 0.9835 0.709',
    pcolorAccent: '0.3125 0.3927 1',
    pcolorUI: '0.1888 0.179 0.2381',

    pcolortextAi: '0.8521 0.7802 0.8341',
    pcolortextYou: '0.7254 0.7572 0.8208',
    pcolortextCorrect: '0.132 0.0902 0.0274',
};
